<template>
  <div class="workspace">
    <div class="bg bg--lt"></div>
    <div class="bg bg--lb"></div>
    <div class="bg bg--rt"></div>
    <div class="bg bg--rb"></div>

    <v-btn text @click="onDrawer = true" class="text-body-2 axis axis--top">{{ sheet.top }}</v-btn>
    <v-btn text @click="onDrawer = true" class="text-body-2 axis axis--bottom">{{ sheet.bottom }}</v-btn>
    <v-btn text @click="onDrawer = true" class="text-body-2 axis axis--left">{{ sheet.left }}</v-btn>
    <v-btn text @click="onDrawer = true" class="text-body-2 axis axis--right">{{ sheet.right }}</v-btn>

    <v-app-bar
      fixed
      color="grey lighten-4"
      dense
      flat
    >
      <v-btn
        icon
        to="/list"
      >
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>
        {{ sheet.name }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <Publish :sheet="sheet"></Publish>

      <v-btn
        icon
        @click="exportSheet()"
      >
        <v-icon color="primary">mdi-download</v-icon>
      </v-btn>

      <v-btn
        icon
        @click="onDrawer = true"
      >
        <v-icon color="primary">mdi-cog</v-icon>
      </v-btn>

    </v-app-bar>

    <p class="page-message" v-if="showPageMessage">{{ $t('Workspace.firstMessage') }}</p>

    <v-navigation-drawer
      v-model="onDrawer"
      fixed
      temporary
      right
      width="300"
    >
      <Setting :sheet="sheet"></Setting>
    </v-navigation-drawer>

    <!-- workspace -->
    <svg style="position: absolute; left: -600px; top: -600px">
      <defs>
        <path id="path" d="M 25,100 A 75,75 0 1,1 175,100 A 75,75 0 1,1 25,100 z" stroke="none" fill="white"/>
        <clipPath id="masking">
          <circle cx="100" cy="100" r="75" fill="none" stroke="none" />
        </clipPath>
      </defs>
    </svg>
    <v-main>
      <template v-for="(object, key) in sheet.objects">
        <div
          :key="'drag' + key"
          :style="{
            zIndex: 1,
            position: 'absolute',
            left: 'calc(' + object.position.left + 'vw - ' + master.sizes[object.size].object / 2 + 'px)',
            top: 'calc(' + object.position.top + 'vh - ' + (master.sizes[object.size].object / 2 + headerHieght) + 'px)'
          }"

          @mouseenter="$event.target.style.zIndex = 2"
          @mouseleave="$event.target.style.zIndex = 1"

          @mousedown.prevent.stop="dragStart($event, object.position)"
          @mouseup.prevent.stop="dragEnd($event, object.position)"

          @touchstart.stop="dragStart($event, object.position)"
          @touchmove.prevent
          @touchend.stop="dragEnd($event, object.position)"
        >
          <Object
            :force-close-object-dialog="forceCloseObjectDialog"
            :object="object"
            :sheet="sheet"
            :key="'object' + key"
          ></Object>
        </div>
      </template>
    </v-main>
    <!-- /workspace -->
  </div>
</template>

<script>
import common from '@/mixins/common'
import db from '@/mixins/db'
import master from '@/json/master.json'
import jsonObject from '@/json/object.json'

import Setting from '@/components/Setting'
import Publish from '@/components/Publish'
import Object from '@/components/Object'

export default {
  metaInfo: {
    title: 'ポジショニングマップ'
  },
  mixins: [common, db],
  components: {
    Setting,
    Publish,
    Object
  },
  computed: {
    sheetNo () {
      return parseInt(this.$route.params.sheetNo)
    },
    showPageMessage () {
      return (JSON.stringify(this.sheet.objects) === '{}')
    }
  },
  data () {
    return {
      headerHieght: 48,
      sheet: {},
      onDrawer: false,
      master: master,
      dragging: false,
      startX: 0,
      startY: 0,
      forceCloseObjectDialog: false,
      position: {}
    }
  },
  methods: {
    toFacebook () {
      // イベントカテゴリ, イベントアクション, イベントラベル
      this.$ga.event('footer', 'link', 'facebookで紹介')
    },
    toTwitter () {
      // イベントカテゴリ, イベントアクション, イベントラベル
      this.$ga.event('footer', 'link', 'Twitterで紹介')
    },
    drag (e) {
      const left = e.pageX || e.changedTouches[0].pageX
      const top = e.pageY || e.changedTouches[0].pageY

      // パーセントに変換
      this.position.left = left / window.innerWidth * 100
      this.position.top = top / window.innerHeight * 100

      this.forceCloseObjectDialog = true
    },
    dragStart (e, position) {
      // drag開始
      this.dragging = true

      // 対象設定
      this.position = position

      // 開始位置
      this.startX = e.pageX || e.changedTouches[0].pageX
      this.startY = e.pageY || e.changedTouches[0].pageY

      // マウスイベント登録
      document.addEventListener('touchmove', this.drag)
      document.addEventListener('mousemove', this.drag)
    },
    dragEnd (e, position) {
      // マウスイベント破棄
      document.removeEventListener('touchmove', this.drag)
      document.removeEventListener('mousemove', this.drag)

      // 終了位置
      const endX = e.pageX || e.changedTouches[0].pageX
      const endY = e.pageY || e.changedTouches[0].pageY

      // object移動距離
      const distance = Math.sqrt(Math.pow(endX - this.startX, 2) + Math.pow(endY - this.startY, 2))

      if (distance > 3) {
        // drag処理、drag中はupdateしないため
        this.updateSheet()
      }

      // drag終了
      this.dragging = false
      this.forceCloseObjectDialog = false
    },
    createObject (left, top) {
      const id = this.getId()
      const object = JSON.parse(JSON.stringify(jsonObject))
      object.id = id
      object.position.left = left / window.innerWidth * 100 // パーセント
      object.position.top = top / window.innerHeight * 100 // パーセント
      this.$set(this.sheet.objects, id, object)
    },
    // -------- DB利用 --------
    getSheet () {
      this.openDb(() => {
        const store = this.startTransaction('readonly')
        const req = store.get(this.sheetNo)
        req.onsuccess = (e) => {
          this.sheet = req.result
        }
        req.onerror = (e) => {
          alert('[getSheet openDb Error] Sorry, application error.')
          return false
        }
      })
    },
    updateSheet () {
      this.openDb(() => {
        const store = this.startTransaction('readwrite')
        this.sheet.time = this.getTime()
        const req = store.put(this.sheet)
        req.onsuccess = (e) => {
        }
        req.onerror = (e) => {
          alert('[updateSheet openDb Error] Sorry, application error.')
          return false
        }
      })
    },
    exportSheet () {
      // イベントカテゴリ, イベントアクション, イベントラベル
      this.$ga.event('header', 'click', 'export')

      const download = require('js-file-download')
      this.openDb(() => {
        const store = this.startTransaction('readonly')
        const req = store.get(this.sheetNo)
        req.onsuccess = (e) => {
          const sheet = req.result
          delete sheet.no
          download(JSON.stringify(req.result), 'Sheet' + this.sheetNo + '.positioningmap')
        }
        req.onerror = (e) => {
          alert('[getSheet openDb Error] Sorry, application error.')
          return false
        }
      })
    }
    // -------- /DB利用 --------
  },
  created () {
    if (!this.sheetNo) {
      alert('Sorry, no data.')
      this.$router.push('/list')
      return false
    }

    this.getSheet()

    document.addEventListener('click', (e) => {
      if (e.target.className === 'v-application--wrap' || e.target.className === 'workspace') {
        // objectを新規作成
        this.createObject(e.pageX, e.pageY)
      }
      return false
    })
  },
  updated () {
    if (this.dragging === false) {
      this.updateSheet()
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.workspace {
  position: relative;
  width: 100vw;
  height: calc(100vh - 48px);
  margin-top: 48px;
  .bg {
    position: absolute;
    pointer-events: none;
    width: 50%;
    height: 50%;
    &--lt {
      left: 0;
      top: 0;
      border-right: 1px solid #ccc;
    }
    &--lb {
      left: 0;
      top: 50%;
      border-right: 1px solid #ccc;
      border-top: 1px solid #ccc;
    }
    &--rt {
      left: 50%;
      top: 0;
    }
    &--rb {
      left: 50%;
      top: 50%;
      border-top: 1px solid #ccc;
    }
  }
  .axis {
    position: absolute;
    &--top {
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
    &--bottom {
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
    &--left {
      top: 46%;
      left: 0;
    }
    &--right {
      top: 46%;
      right: 0;
    }
  }
}
</style>
